import React, { Component } from 'react';
import { Field } from 'formik';
import P from 'prop-types';

import Button from 'components/Button/';

import './PasswordMaskField.scss';

export default class PasswordMaskField extends Component {

  state = {
    showPassword: false,
  };

  static propTypes = {
    id: P.string.isRequired,
    name: P.string.isRequired,
    placeholder: P.string,
  };

  render() {
    return (
      <div className="PasswordMaskField">
        <Field {...this.props} type={this.state.showPassword ? 'text' : 'password'} className="PasswordMaskField-input _lr-hide" />
        <Button
          className="PasswordMaskField-showButton"
          underlineText
          color="transparent"
          onClick={(evt) => {
            evt.preventDefault();
            this.setState({ showPassword: !this.state.showPassword });
        }}>
          Show
        </Button>
      </div>
    );
  }
}
